(function () {
  if (window.CartFreeShipping) {
    window.CartFreeShipping.initAll();
    return;
  }

  function formatMoney(cents) {
    var amount = Math.max(0, cents);
    var currency = window.themeVendor && window.themeVendor.themeCurrency;
    var moneyFormat = window.theme && window.theme.moneyFormat;
    var formatted;

    if (currency && moneyFormat) {
      formatted = currency.formatMoney(amount, moneyFormat);
      if (window.theme.settings && window.theme.settings.currency_code_enable && window.theme.currencyCode) {
        formatted += ' ' + window.theme.currencyCode;
      }
      return formatted;
    }

    return (amount / 100).toFixed(2);
  }

  function currencyRate() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      var rate = Number(window.Shopify.currency.rate);
      if (!isNaN(rate) && rate > 0) return rate;
    }
    return 1;
  }

  function init(bar) {
    if (bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';

    var threshold = Number(bar.getAttribute('data-threshold')) * currencyRate();
    var remainingTemplate = bar.getAttribute('data-remaining-template') || '';
    var almostEl = bar.querySelector('[data-free-shipping-almost]');
    var eligibleEl = bar.querySelector('[data-free-shipping-eligible]');
    var remainingEl = bar.querySelector('[data-free-shipping-remaining]');
    var fillEl = bar.querySelector('[data-free-shipping-fill]');

    function isCart(cart) {
      return !!(cart && Array.isArray(cart.items) && cart.item_count != null);
    }

    function render(cart) {
      if (!isCart(cart)) return;

      var itemCount = Number(cart.item_count) || 0;
      var total = Number(cart.total_price) || 0;
      var remaining = Math.max(0, threshold - total);
      var eligible = itemCount > 0 && total >= threshold && threshold > 0;
      var percent = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;

      bar.hidden = itemCount < 1;
      bar.classList.toggle('is-complete', eligible);
      if (almostEl) almostEl.hidden = eligible;
      if (eligibleEl) eligibleEl.hidden = !eligible;
      if (remainingEl) {
        remainingEl.hidden = eligible;
        remainingEl.innerHTML = remainingTemplate.replace('__AMOUNT__', formatMoney(remaining));
      }
      if (fillEl) fillEl.style.width = percent + '%';
    }

    document.addEventListener('theme:cart:change', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!isCart(cart)) return;
      render(cart);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cart-free-shipping]').forEach(init);
  }

  window.CartFreeShipping = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
